import React, { useMemo, useState } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

export default function TicketsSearcher() {
  const [searchUid, setSearchUid] = useState("");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const toursMeta = [
    { id: "2026-tura-1", label: "Tura 1", hour: "13:00", number: 1 },
    { id: "2026-tura-2", label: "Tura 2", hour: "15:00", number: 2 },
    { id: "2026-tura-3", label: "Tura 3", hour: "17:00", number: 3 },
    { id: "2026-tura-4", label: "Tura 4", hour: "19:00", number: 4 },
  ];

  const getTourMeta = (tourNumber) => {
    return toursMeta.find((t) => t.number === Number(tourNumber)) || null;
  };

  const handleSearch = async () => {
    const uid = String(searchUid || "").trim();

    if (!uid) {
      setError("Wpisz UID użytkownika.");
      setOrders([]);
      return;
    }

    try {
      setLoading(true);
      setError("");
      setOrders([]);

      const q = query(
        collection(db, "gala-purchases2026"),
        where("customer", "==", uid)
      );

      const snap = await getDocs(q);

      const found = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      found.sort((a, b) => {
        const aTime = a?.createdAt?.seconds || 0;
        const bTime = b?.createdAt?.seconds || 0;
        return bTime - aTime;
      });

      setOrders(found);

      if (!found.length) {
        setError("Nie znaleziono zamówień dla tego UID.");
      }
    } catch (err) {
      console.error(err);
      setError("Błąd podczas wyszukiwania zamówień.");
    } finally {
      setLoading(false);
    }
  };

  const groupedStats = useMemo(() => {
    return {
      all: orders.length,
      pending: orders.filter((x) => x?.status === "pending").length,
      done: orders.filter((x) => x?.status === "done").length,
      canceled: orders.filter((x) => x?.status === "canceled").length,
      sold: orders.filter((x) => x?.status === "sold").length,
      accepted: orders.filter((x) => x?.status === "accepted").length,
    };
  }, [orders]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "rgb(240,240,240)",
        width: "100%",
        minHeight: "100vh",
        gap: "25px",
        paddingTop: "40px",
        paddingBottom: "50px",
      }}
    >
      <div
        style={{
          width: "92%",
          maxWidth: "900px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            color: "rgb(30,30,30)",
            margin: 0,
            textAlign: "center",
          }}
        >
          Wyszukiwarka zamówień biletów
        </h2>

        <div
          style={{
            backgroundColor: "rgb(255,255,255,0.82)",
            borderRadius: "10px",
            padding: "20px",
            boxShadow:
              "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <h3
            style={{
              fontSize: "14px",
              color: "rgb(80,80,80)",
              margin: 0,
              fontWeight: "bold",
            }}
          >
            UID użytkownika / ownerUid konta kupującego
          </h3>

          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <input
              value={searchUid}
              onChange={(e) => setSearchUid(e.target.value)}
              placeholder="Wpisz UID użytkownika"
              style={{
                flex: "1 1 320px",
                height: "40px",
                borderRadius: "6px",
                border: "1px solid rgba(30,30,30,0.18)",
                padding: "0 12px",
                fontSize: "13px",
                outline: "none",
                backgroundColor: "white",
              }}
            />

            <button
              onClick={handleSearch}
              disabled={loading}
              className="button-black"
              style={{
                minWidth: "140px",
                height: "40px",
                fontSize: "13px",
                color: "white",
                borderRadius: "6px",
                cursor: loading ? "default" : "pointer",
                opacity: loading ? 0.75 : 1,
              }}
            >
              {loading ? "Wyszukiwanie..." : "Szukaj"}
            </button>
          </div>

          {error && (
            <div
              style={{
                backgroundColor: "rgba(220,20,60,0.08)",
                border: "1px solid rgba(220,20,60,0.18)",
                borderRadius: "6px",
                padding: "10px 12px",
                color: "#DC143C",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {error}
            </div>
          )}
        </div>

        {orders.length > 0 && (
          <div
            style={{
              backgroundColor: "rgb(255,255,255,0.82)",
              borderRadius: "10px",
              padding: "16px 20px",
              boxShadow:
                "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <h3 style={{ fontSize: "13px", margin: 0, color: "rgb(30,30,30)" }}>
              Wszystkie: <b>{groupedStats.all}</b>
            </h3>
            <h3 style={{ fontSize: "13px", margin: 0, color: "#c58a00" }}>
              Pending: <b>{groupedStats.pending}</b>
            </h3>
            <h3 style={{ fontSize: "13px", margin: 0, color: "#12B552" }}>
              Done: <b>{groupedStats.done}</b>
            </h3>
            <h3 style={{ fontSize: "13px", margin: 0, color: "#0045C7" }}>
              Sold: <b>{groupedStats.sold}</b>
            </h3>
            <h3 style={{ fontSize: "13px", margin: 0, color: "#6c757d" }}>
              Accepted: <b>{groupedStats.accepted}</b>
            </h3>
            <h3 style={{ fontSize: "13px", margin: 0, color: "#DC143C" }}>
              Canceled: <b>{groupedStats.canceled}</b>
            </h3>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          {orders.map((order) => (
            <div
              key={order.id}
              style={{
                backgroundColor: "rgb(255,255,255,0.82)",
                borderRadius: "10px",
                padding: "20px",
                boxShadow:
                  "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.5px, rgb(209, 213, 219) 0px 0px 0px 1px",
                display: "flex",
                flexDirection: "column",
                gap: "14px",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                  gap: "12px",
                }}
              >
                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    ID zamówienia
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color: "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                      wordBreak: "break-word",
                    }}
                  >
                    {order?.id}
                  </h3>
                </div>

                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    Status
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color:
                        order?.status === "done"
                          ? "#12B552"
                          : order?.status === "pending"
                          ? "#c58a00"
                          : order?.status === "canceled"
                          ? "#DC143C"
                          : "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                    }}
                  >
                    {order?.status || "-"}
                  </h3>
                </div>

                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    UID klienta
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color: "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                      wordBreak: "break-word",
                    }}
                  >
                    {order?.customer || "-"}
                  </h3>
                </div>

                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    Email
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color: "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                      wordBreak: "break-word",
                    }}
                  >
                    {order?.customerEmail || "-"}
                  </h3>
                </div>

                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    Suma
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color: "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                    }}
                  >
                    {order?.total ?? 0} zł
                  </h3>
                </div>

                <div>
                  <h3
                    style={{
                      fontSize: "12px",
                      color: "rgb(120,120,120)",
                      margin: 0,
                    }}
                  >
                    Liczba miejsc
                  </h3>
                  <h3
                    style={{
                      fontSize: "14px",
                      color: "rgb(35,35,35)",
                      margin: "4px 0 0 0",
                    }}
                  >
                    {Array.isArray(order?.seats) ? order.seats.length : 0}
                  </h3>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "rgba(0,0,0,0.08)",
                }}
              />

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <h3
                  style={{
                    fontSize: "14px",
                    color: "rgb(30,30,30)",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                >
                  Miejsca w zamówieniu
                </h3>

                {Array.isArray(order?.seats) && order.seats.length > 0 ? (
                  order.seats.map((seat, index) => {
                    const tour = getTourMeta(seat?.tour);

                    return (
                      <div
                        key={`${order.id}_${index}`}
                        style={{
                          padding: "10px 12px",
                          borderRadius: "6px",
                          backgroundColor: "rgba(0,0,0,0.03)",
                          fontSize: "13px",
                          color: "rgb(45,45,45)",
                        }}
                      >
                        {seat?.isDiscount ? "Bilet ulgowy" : "Bilet normalny"} |{" "}
                        Tura {seat?.tour}
                        {tour?.hour ? ` | ${tour.hour}` : ""} | Rząd:{" "}
                        {String(seat?.row || "").toUpperCase()} | Miejsce:{" "}
                        {seat?.num} | Cena: {seat?.finalPrice ?? seat?.price ?? 0} zł
                      </div>
                    );
                  })
                ) : (
                  <h3
                    style={{
                      fontSize: "13px",
                      color: "rgb(120,120,120)",
                      fontWeight: "normal",
                      margin: 0,
                    }}
                  >
                    Brak miejsc w zamówieniu.
                  </h3>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}